<template>
	<span>
		<b-img
			:src="appLogoImage"
			alt="AgentScout" 
			class="logo"
		/>
	</span>
</template>

<script>
import { BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BImg,
  },
  setup() {
    // App Name
    const { appLogoImage } = $themeConfig.app
    return {
      appLogoImage,
    }
  },
}
</script>

<style>
	.logo{
		width: 180px;
	}
</style>